import React from 'react'
import * as styles from './index.scss'

interface Props {
  title: string
  type?: 'normal' | 'video'
  loading?: boolean
  style?: React.CSSProperties
}

const CardLayout: React.SFC<Props> = ({
  children,
  title,
  type = 'normal',
  loading,
  style,
}) => {
  const item = (com, key) => (
    <div key={key} className={styles.cardlayoutBodyItem}>
      {com}
    </div>
  )
  const childs =
    type === 'video' ? (
      <div className={styles.cardlayoutBody}>
        {!![].concat(children).length &&
          [].concat(children).map((com, idx) => item(com, idx))}
      </div>
    ) : (
      children
    )
  return (
    <div className="cardlayout" style={style}>
      <div className={styles.cardlayoutHeader}>
        <span>{title}</span>
      </div>
      <div className={styles.cardlayoutInner}>
        {loading ? (
          <div className={styles.nodata}>努力加载中...</div>
        ) : children ? (
          childs
        ) : (
          <div className={styles.nodata}>暂时什么都没有喔</div>
        )}
      </div>
    </div>
  )
}

export default CardLayout
